// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    admin_CMS: true,
    firebaseconfig: {
        apiKey: 'AIzaSyB0yqpv2drBLgCYe30XpOq8toX2lu5Sz-s',
        authDomain: 'rollingtrans-dev.firebaseapp.com',
        databaseURL: 'https://rollingtrans-dev.firebaseio.com',
        projectId: 'rollingtrans-dev',
        storageBucket: 'rollingtrans-dev.appspot.com',
        messagingSenderId: '414519301275',
    },
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts